var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMemberJourney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 -444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8021 10.9969 18.4479 7.64271C18.1604 7.45104 17.7771 7.49896 17.5375 7.73854 17.2979 7.97812 17.25 8.36146 17.4417 8.64896L19.574 10.7812 17.0104 10.7812C16.3396 10.7812 15.6208 10.8052 14.8542 10.8052 10.6854 10.8771 4.36042 10.9729 3.30625 8.57708 3.13854 8.21771 2.73125 8.05 2.34792 8.21771 1.98854 8.38542 1.82083 8.79271 1.98854 9.17604 3.21042 11.9073 7.81042 12.2906 12.2667 12.2906 13.1531 12.2906 14.0396 12.2667 14.8781 12.2667 15.6448 12.2427 16.3635 12.2427 17.0104 12.2427L19.5979 12.2427 17.4656 14.375C17.25 14.6625 17.274 15.0698 17.5135 15.3333 17.7531 15.5969 18.1844 15.6208 18.4719 15.3812L21.826 12.0271C21.8979 11.9552 21.9458 11.8833 21.9698 11.7875 21.9698 11.7635 21.9937 11.7396 21.9937 11.7156 21.9937 11.6917 21.9937 11.6917 22.0177 11.6677 22.0177 11.6437 22.0177 11.6198 22.0177 11.5958 22.0177 11.5719 22.0177 11.5479 22.0177 11.524 22.0177 11.5 22.0177 11.5 22.0177 11.476 21.9937 11.2844 21.9219 11.1167 21.8021 10.9969Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.04348 12 444)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemberJourney);
export default __webpack_public_path__ + "static/media/icon-member-journey.b0344cefe69e2eecf300d8371647320a.svg";
export { ForwardRef as ReactComponent };